import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import State from '../../../application/core/State';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import EstimationsDraftSaveSucceed from '../events/EstimationsDraftSaveSucceed';
import EstimationsDraftSaveRequested from '../events/EstimationsDraftSaveRequested';
import EstimationSafeDraftFailed from '../events/EstimationSafeDraftFailed';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(EstimationsDraftSaveRequested.type),
        mergeMap(() =>
            backend
                .put(
                    `${api()}users/${state$.value.user.customerId}/estimations/draft`,
                    JSON.stringify(state$.value.estimations.estimations)
                )
                .pipe(
                    map(() => new EstimationsDraftSaveSucceed(state$.value.estimations.estimations)),
                    catchError(() => of(new EstimationSafeDraftFailed()))
                )
        )
    );



// WEBPACK FOOTER //
// ./src/application/estimations/epic/estimationDraftUpdate.ts